export const VARIATION_SEPARATE_ASSET_BANNER = 'separate_asset_and_counter'
export const VARIATION_ASSET_IN_BANNER = 'asset_in_counter'
export const VARIATION_BANNER_ONLY = 'counter_only'
